import React, { Component } from 'react';
import MiniMessage from '../baseComponents/MiniMessage';

export default class Home extends Component{
  constructor(props) {
    super(props);
    this.state = { placeholder: 'home' };
  };

  render() {
    return (
      <MiniMessage content={`This is the ${this.state.placeholder} page.`}/>
    );
  }
}